import { SharingArrangementModelUnit } from '@g2-shared/api-client/generated/settlement-app';

export const SharingArrangementModelUnitLabelMapper: Record<SharingArrangementModelUnit, string> = {
  [SharingArrangementModelUnit.NONE]: 'None',
  [SharingArrangementModelUnit.FEE_AMOUNT]: 'Fee_amount',
  [SharingArrangementModelUnit.TX_AMOUNT]: 'Tx_amount',
  [SharingArrangementModelUnit.TX_COUNT]: 'Tx_count',
};
